import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
    palette: {
        mode: 'light',
        background: {
            default: '#f4f6f8',    // Light grey page background
            paper: '#ffffff',    // White surfaces (cards, dialogs)
            sidebar: '#eef1f5',    // Slightly tinted for sidebar
            suggestion: '#e0e0e0',
            sender: '#fce3cd',
            suggestionHover: '#d0d0d0',
            suggestionBorder: '#2b2d31',
            chatBorder: 'rgb(198, 198, 184)'
        },
        primary: {
            main: '#8a84ff',       // Same accent as dark mode
        },
        text: {
            primary: '#000000',   // Dark text on light surfaces
            secondary: '#555555',   // Muted text
        },
    },
    typography: {
        fontFamily: 'var(--inter-font)',
        body1: {
            fontSize: '0.9rem',
        },
        body2: {
            fontSize: '0.8rem',
        },
        button: {
            textTransform: 'none',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});

export default lightTheme;